import { Component } from '@angular/core';

@Component({
  selector: 'app-smoketest',
  templateUrl: './smoketest.component.html',
})
export class SmokeTestComponent {}
